import { ErrorView } from "@/components/ui/layout/error/errorView"
import { type BoxOfferInvitationLink } from "@modules/boxOffer/entities/boxOfferTypes"
import { MemberDetailsInfo } from "@modules/members/components/memberDetailsInfo"
import { MemberDetailsSkeleton } from "@modules/members/components/memberDetailsSkeleton"
import { MemberOfferInvitation } from "@modules/members/memberOffers/components/memberOfferInvitation"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { type SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { LoadingSpinner } from "@/modules/ui/components/loading"

export const useMemberSideBar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToMemberDetailsInfo = (memberId: string, args?: SidebarNavigatorParams) => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<MemberDetailsSkeleton />}>
            <MemberDetailsInfo memberId={memberId} />
          </Suspense>
        </ErrorBoundary>
      ),
      ...args,
    })
  }

  const navigateToMemberOfferInvitation = (
    boxOfferInvitationLink: BoxOfferInvitationLink,
    args?: SidebarNavigatorParams,
  ) => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <MemberOfferInvitation boxOfferInvitationLink={boxOfferInvitationLink} />
          </Suspense>
        </ErrorBoundary>
      ),
      ...args,
    })
  }

  return { navigateToMemberOfferInvitation, navigateToMemberDetailsInfo }
}
